import { render, staticRenderFns } from "./childItem.vue?vue&type=template&id=7b5f45f4&scoped=true"
import script from "./childItem.vue?vue&type=script&lang=js"
export * from "./childItem.vue?vue&type=script&lang=js"
import style0 from "./childItem.vue?vue&type=style&index=0&id=7b5f45f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f45f4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/aside/childItem.vue
// module id = null
// module chunks = 